export function checkPasswordStrength(password) {
	const minLength = 8
	const maxLength = 15
	const hasUppercase = /[A-Z]/.test(password)
	const hasLowercase = /[a-z]/.test(password)
	const hasDigit = /\d/.test(password)
	const hasSpecialChar = /[!@#$%^&*()_+{}\[\]:;<>,.?~`]/.test(password)

	if (password.length < minLength || password.length > maxLength || !hasUppercase || !hasLowercase || !hasDigit || !hasSpecialChar) {
		return 'weak'
	}

	return 'strong'
}

export function formatDate(dateString) {
	const date = new Date(dateString) // Parse the date string to Date object
	const day = String(date.getDate()).padStart(2, '0') // Get day and pad with zero if needed
	const month = String(date.getMonth() + 1).padStart(2, '0') // Get month (0-based index) and pad
	const year = date.getFullYear() // Get year

	return `${day}-${month}-${year}` // Return in dd-mm-yyyy format
}

export function formatDateWithTime(dateString) {
	const date = new Date(dateString) // Parse the date string to Date object

	// Format date
	const day = String(date.getDate()).padStart(2, '0') // Get day and pad with zero if needed
	const month = String(date.getMonth() + 1).padStart(2, '0') // Get month (0-based index) and pad
	const year = date.getFullYear() // Get year

	// Format time
	let hours = date.getHours() // Get hours
	const minutes = String(date.getMinutes()).padStart(2, '0') // Get minutes and pad
	const seconds = String(date.getSeconds()).padStart(2, '0') // Get seconds and pad
	const ampm = hours >= 12 ? 'PM' : 'AM' // Determine AM/PM

	hours = hours % 12 || 12 // Convert to 12-hour format, handling midnight (0 hours) as 12

	// Return date and time in the desired format with time in parentheses
	return `${day}-${month}-${year} (${hours}:${minutes}:${seconds} ${ampm})`
}

export function capitalizeFirstLetter(string) {
	if (!string) return '' // Handle empty or undefined strings
	return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase() // Capitalize first letter and lowercase the rest
}

export function calculateAge(dob) {
	if (!dob || typeof dob !== 'string') {
		console.error('Invalid DOB format')
		return
	}

	const [year, month, day] = dob.split('-').map(Number) // Ensure correct ordering
	const birthDate = new Date(year, month - 1, day)

	// Get the current date
	const currentDate = new Date()

	// Calculate the age
	let age = currentDate.getFullYear() - birthDate.getFullYear()

	// Check if the birthday has occurred this year or not
	const monthDiff = currentDate.getMonth() - birthDate.getMonth()
	if (monthDiff < 0 || (monthDiff === 0 && currentDate.getDate() < birthDate.getDate())) {
		age--
	}
	return age
}

export const truncateText = (html, maxLength) => {
	const tmp = document.createElement('div')
	tmp.innerHTML = html
	let text = tmp.textContent || tmp.innerText || ''
	return text.length > maxLength ? text.substr(0, maxLength - 1) + '…' : text
}

// Function to safely truncate HTML content
export const truncateHTML = (html, maxLength) => {
	const tmp = document.createElement('div')
	tmp.innerHTML = html
	let text = tmp.textContent || tmp.innerText || ''
	return text.length > maxLength ? text.substr(0, maxLength - 1) + '…' : text
}
// export const truncateText = (text, maxLength) => {
// 	// Replace <h2> with <p> and </h2> with </p>
// 	const modifiedText = text.replace(/<h2>/g, '<p>').replace(/<\/h2>/g, '</p>')

// 	// Truncate text if it exceeds maxLength
// 	return modifiedText.length > maxLength ? modifiedText.slice(0, maxLength) + '...' : modifiedText
// }
